import { useTranslation } from "react-i18next";

import { DeleteButton } from "@/features/FormCard/Actions";
import { DeleteConfirmationModal } from "@/features/FormCard/Modals";
import { useBulkDelete } from "./useBulkDelete";

type DeletableRow = { id: number };

export function useBulkDeleteControls<T extends DeletableRow>({
  client,
  table_name,
  resourceLabel,
}: {
  client: string;
  table_name: string;
  resourceLabel: string;
}) {
  const { t } = useTranslation();
  const bulkDelete = useBulkDelete({ client, table_name });

  const selectionActions = (selectedRows: T[], clearSelection: () => void) => {
    if (selectedRows.length === 0) return null;
    return (
      <DeleteButton
        isDisabled={bulkDelete.isLoading}
        onPress={() =>
          bulkDelete.openConfirm(
            selectedRows.map((row) => row.id),
            clearSelection,
          )
        }
      >
        {t("actions.bulk_delete", { count: selectedRows.length })}
      </DeleteButton>
    );
  };

  const modal = (
    <DeleteConfirmationModal
      isOpen={bulkDelete.isOpen}
      onClose={bulkDelete.cancelDelete}
      onDelete={bulkDelete.confirmDelete}
      isLoading={bulkDelete.isLoading}
      body={t("delete_confirm.bulk_body_resource", {
        count: bulkDelete.count,
        resource: resourceLabel,
      })}
      requireTyping
    />
  );

  return { selectionActions, modal };
}
